import type { Ref, MutableRefObject, RefCallback } from 'react';

/**
 * Merges multiple React refs into a single callback ref.
 * Accepts ref objects, callback refs, or null/undefined — any combination.
 */
export function mergeRefs<T>(
  ...refs: (Ref<T> | undefined)[]
): RefCallback<T> {
  return (value: T | null) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref != null) {
        (ref as MutableRefObject<T | null>).current = value;
      }
    }
  };
}
